import { FC } from 'react';
import { Banner, Novelties } from '@bpba/modules-components';
import { GenericComponentProps } from '@bpba/modules-components';
import { Box } from '@bpba/ui-components';
import { useUserStatus } from '../../config/authentication/useUserStatus';

export const NoveltiesWrapper: FC<GenericComponentProps<Banner>> = (props) => {
  const { isLoggedin } = useUserStatus();

  return (
    <Box paddingTop={['0px', null, null, isLoggedin ? '40px' : 0]}>
      <Novelties {...props} />
    </Box>
  );
};
